export default {
  header: 'Nuovi ordini in pausa',
  text: 'Tocca ovunque per ripristinare',
};
